// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
// import VueQrcodeReader from "vue-qrcode-reader";
import VueCookie from "vue-cookie";
import VCalendar from 'v-calendar';

// import VueGoogleMaps from 'vue-google-maps-location-selector';
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// import source data
import routes from './routes/routes'
import config from './config/config'
import locale from './config/locale'
import store from './store'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import Notifications from './plugins/NotificationPlugin'
import SideBar from './plugins/SidebarPlugin'
import Material from './plugins/MaterialPlugin'
// MaterialDashboard plugin

import 'vue-datetime/dist/vue-datetime.css'
import "vue-select/src/scss/vue-select.scss";

// merge resources to vue instance
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(Vuex)
// Vue.use(VueQrcodeReader)
Vue.use(Material)
Vue.use(ElementUI)
Vue.use(GlobalComponents)
Vue.use(GlobalDirectives)
Vue.use(Notifications)
Vue.use(SideBar)
Vue.use(VueCookie);
Vue.use(VCalendar);
// Vue.use(VueGoogleMaps);

// create new vuex store
let VuexStore = new Vuex.Store(store);
// create new router
const router = new VueRouter({
	routes,
	mode: 'history',
	linkExactActiveClass: 'nav-item active'
})



Vue.http.interceptors.push((request, next) => {
	request.headers.set('Authorization', VuexStore.state.authentication.authToken);
	request.headers.set("Content-Type", "application/json");

	next((res) => {
		if (res.status === 200 && res.ok === true) {
			switch (res.body.status) {
				case 'expired':
					// Vue.prototype.$notification.notify({
					// 	message: res.body.message,
					// 	icon: 'error',
					// 	type: 'danger'
					// })
					VuexStore.state.authentication.authToken = null
					Vue.prototype.$cookie.delete("auth");
					VuexStore.state.authentication.loggedIn = false
					VuexStore.state.authentication.checked = true
					window.location.replace("/");
					break;
				case 'fail':
					Vue.prototype.$notification.notify({
						message: res.body.message,
						icon: 'error',
						type: 'danger'
					})
					break;
				case 'error':
					Vue.prototype.$notification.notify({
						message: "Can't communicate with the server !||មិនអាចតភ្ជាប់ទៅកាន់ម៉ាស៊ីនមេបាន !",
						icon: 'error',
						type: 'danger'
					})
					break;
			}
		} else if (res.ok === false) {
			Vue.prototype.$notification.notify({
				message: "No internet connection !||មានបញ្ហាអុីនធឺណិត !",
				icon: 'error',
				type: 'danger'
			})
		}

	})
})

Vue.prototype.config = config
Vue.prototype.locale = locale

Vue.prototype.translate = function(data) {
	if(Array.isArray(data)) {
		let lang = VuexStore.state.l.lang < data.length ? VuexStore.state.l.lang : 0;
		return data[lang];
	} else {
		let array = String(data).split("||");
		let lang = VuexStore.state.l.lang < array.length ? VuexStore.state.l.lang : 0;
		return array[lang];
	}
	
}

Vue.prototype.translateNumber = function(data) {
	let lang = VuexStore.state.l.lang === 1 ? VuexStore.state.l.lang : 0;

	if(lang == 0) {
		return String(data).replaceAll("១", "1").replaceAll("២", "2").replaceAll("៣", "3").replaceAll("៤", "4").replaceAll("៥", "5").replaceAll("៦", "6").replaceAll("៧", "7").replaceAll("៨", "8").replaceAll("៩", "9").replaceAll("០", "0")
	} else {
		return String(data).replaceAll("1", "១").replaceAll("2", "២").replaceAll("3", "៣").replaceAll("4", "៤").replaceAll("5", "៥").replaceAll("6", "៦").replaceAll("7", "៧").replaceAll("8", "៨").replaceAll("9", "៩").replaceAll("0", "០")
	}
}

/* eslint-disable no-new */
new Vue({
	el: '#app',
	render: h => h(App),
	store: VuexStore,
	router
})



// WEBPACK FOOTER //
// ./src/main.js